import RootStore from '@App/stores/root-store'
import { action, makeObservable, observable, runInAction } from 'mobx'
import { getSongwriterSummary } from '@App/api/routes/songwriter/songwriter'
import { SongwriterSummary } from '@Entities/songwriter/songwriter-summary'

class CurrentSongwriterStore {
    private rootStore: RootStore
    private _currentSongwriterId: string | undefined
    private _songwriterSummary: SongwriterSummary | undefined

    constructor(rootStore: RootStore) {
        makeObservable<CurrentSongwriterStore, '_currentSongwriterId' | '_songwriterSummary'>(this, {
            _currentSongwriterId: observable,
            _songwriterSummary: observable,
            setCurrentSongwriterId: action,
            destroySongwriter: action,
        })
        this.rootStore = rootStore
    }

    get currentSongwriterId(): string {
        if (this._currentSongwriterId) {
            return this._currentSongwriterId
        } else {
            throw new Error('Songwriter ID Is Missing')
        }
    }

    get songwriterSummary() {
        if (this._songwriterSummary) {
            return this._songwriterSummary
        } else {
            throw new Error('Songwriter Summary Is Missing')
        }
    }

    get optionalSongwriterSummary() {
        return this._songwriterSummary
    }

    get optionalCurrentSongwriterId(): string | undefined {
        return this._currentSongwriterId
    }

    public setCurrentSongwriterId = async (songwriterId: string | undefined) => {
        if (this._currentSongwriterId !== songwriterId) {
            this.rootStore.preloaderStore.openTransparentPreloader(true)
            this._currentSongwriterId = songwriterId
            await this.loadSongwriterSummary()
            this.rootStore.preloaderStore.openTransparentPreloader(false)
        }
    }

    public async loadSongwriterSummary() {
        const response = await getSongwriterSummary(this.currentSongwriterId)
        runInAction(() => (this._songwriterSummary = response.data))
    }

    public destroySongwriter() {
        this._currentSongwriterId = undefined
        this._songwriterSummary = undefined
    }
}

export default CurrentSongwriterStore
